import { Form } from "antd";

import { LossReasonSelect as BaseSelect } from "../../../selects/loss-reason-select";

export const LossReasonSelect = (props) => {
  const { form, lostOpportunityStates, organization } = props;

  const opportunityStateChangeId = Form.useWatch(
    "opportunityStateChangeId",
    form
  );

  const isLost = (lostOpportunityStates || []).some(
    ({ _id }) => Number(_id) === Number(opportunityStateChangeId)
  );

  if (!isLost) {
    return null;
  }

  return (
    <BaseSelect
      label="Reason for Loss"
      name="lossReasonId"
      {...(organization.shouldEnforceLossReason
        ? { rules: [{ required: true }] }
        : {})}
    />
  );
};
